import { FunctionComponent } from "react";
import "./PoolPageActions.scss";
import StackIcon from "./images/stack-icon.svg";
import VoteIcon from "./images/vote-icon.svg";
import InvestIcon from "./images/invest-icon.svg";
import RefundIcon from "./images/refund-icon.svg";
import ClaimIcon from "./images/claim-icon.svg";
import ActionCard from "./ActionCard";

const PoolPageActions: FunctionComponent<{}> = () => {
    return (
        <>
            <div className="pool-page-actions">
                <ActionCard icon={StackIcon} title={"Stake"} amount={1135.20} suffix={"BLS"} />
                <ActionCard icon={VoteIcon} title={"Vote"} amount={1135.20} suffix={"BLS"} />
                <ActionCard icon={InvestIcon} title={"Invest"} amount={0.0058} suffix={"$ABC/BNB"} />
                <ActionCard icon={RefundIcon} title={"Refund"} amount={1.05} suffix={"BNB"} />
                <ActionCard icon={ClaimIcon} title={"Claim"} amount={25365} suffix={"$ABC"} />
            </div>
        </>
    );
};

export default PoolPageActions;
